<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Что такое заявки на&nbsp;услуги</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="chto-takoye-zayavki-na-uslugi"
            class="typography__headline2"
          >
            Что такое заявки на&nbsp;услуги
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;MyDonut предусмотрели работу с&nbsp;услугами без записи&nbsp;&mdash; по&nbsp;заявкам.</p>

            <p>
              У&nbsp;таких услуг может быть название, описание, стоимость, длительность (если нужно) и&nbsp;галерея
              изображений.
            </p>

            <p>
              Клиентам будет доступен каталог с&nbsp;этими услугами, где они смогут посмотреть их&nbsp;информацию,
              выбрать нужную услугу и&nbsp;оформить на&nbsp;неё заявку.
            </p>

            <p>
              У&nbsp;вас будет отдельный раздел со&nbsp;списком всех заявок и&nbsp;возможностью удобно ими управлять.
              Сами добавить заявку вы&nbsp;тоже сможете.
            </p>

            <p>
              Пример использования: у&nbsp;вас юридическая фирма, предоставляющая услуги удаленно. Клиент выбирает
              в&nbsp;удобном каталоге подходящую услугу, например &laquo;Оформление банкротства&raquo; и&nbsp;оформляет
              заявку. Вы&nbsp;получаете заявку и&nbsp;обрабатываете&nbsp;её.
            </p>

            <p>
              Еще один пример: вы&nbsp;ведущий мероприятий, предоставляющий услуги в&nbsp;своем городе,
              но&nbsp;по&nbsp;заявкам. Клиент выбирает в&nbsp;удобном каталоге подходящую услугу, например
              &laquo;Ведущий на&nbsp;корпоративе&raquo; и&nbsp;оформляет заявку. Вы&nbsp;получаете заявку
              и&nbsp;обрабатываете&nbsp;её.
            </p>
          </div>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="gde-nastraivayutsya"
            class="typography__headline2"
          >
            Где настраивается
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Настройку активности &laquo;Онлайн-запись&raquo; можно найти при
              <BaseLink
                target="_blank"
                to="/faq/articles/dobavleniye-i-redaktirovaniye-uslugi"
                >добавлении или редактировании услуги</BaseLink
              >.
            </p>

            <p>Ей&nbsp;управляется доступна услуга к&nbsp;онлайн-записи или нет. По-умолчанию настройка активна.</p>

            <p>При выключенном состоянии услуга будет доступна в&nbsp;каталоге услуг для оформления заявки.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chto-takoye-zayavki-na-uslugi-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Сотрудников и&nbsp;адреса предоставления у&nbsp;услуг с&nbsp;выключенной онлайн-записью необходимо
              заполнить даже если услуга недоступна для онлайн-записи, но&nbsp;такая информация есть. Это поможет
              клиентам получить больше информации об&nbsp;услуге и&nbsp;фильтровать её&nbsp;в&nbsp;каталоге
              по&nbsp;разным параметрам.
            </p>

            <p>Если вы&nbsp;работаете удаленно и&nbsp;без сотрудников&nbsp;&mdash; блоки можно оставить пустыми.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chto-takoye-zayavki-na-uslugi-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="razdel-s-zayavkami"
            class="typography__headline2"
          >
            Раздел с заявками
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В раздел можно попасть из меню слева нажав на «Услуги».</p>

            <p>
              Здесь
              <BaseLink
                class="ui-link-secondary"
                target="_blank"
                to="/faq/articles/dobavleniye-i-redaktirovaniye-zayavki"
                >добавляются новые заявки</BaseLink
              >, можно
              <BaseLink
                class="ui-link-secondary"
                target="_blank"
                to="/faq/articles/spisok-zayavok-i-ikh-dannye"
                >посмотреть список</BaseLink
              >
              текущих или архивных и&nbsp;управлять ими.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/chto-takoye-zayavki-na-uslugi-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Что такое заявки на&nbsp;услуги разобрались. Самое время перейти к&nbsp;<BaseLink
              class="ui-link-secondary"
              to="/faq/articles/dobavleniye-i-redaktirovaniye-zayavki"
              >добавлению заявок</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Заявки на&nbsp;услуги",
    url: "/faq/categories/zayavki-na-uslugi",
  },
  {
    name: "Что такое заявки на услуги",
  },
];

const menu = [
  {
    name: "Что&nbsp;такое&nbsp;заявки&nbsp;на&nbsp;услуги",
    url: "chto-takoye-zayavki-na-uslugi",
  },
  {
    name: "Где&nbsp;настраивается",
    url: "gde-nastraivayutsya",
  },
  {
    name: "Раздел&nbsp;с&nbsp;заявками",
    url: "razdel-s-zayavkami",
  },
];

const relatedArticles = [
  {
    name: "Список заявок и&nbsp;их данные",
    slug: "spisok-zayavok-i-ikh-dannye",
  },
  {
    name: "Добавление и&nbsp;редактирование заявки",
    slug: "dobavleniye-i-redaktirovaniye-zayavki",
  },
];

useSeoMeta({
  title: "Что такое заявки на услуги",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
